module.exports = __webpack_public_path__ + "img/bb_g3_antenna-06.68fc2c52.svg";